import findColorShadeInPalette from '../utils/find-color-shade-in-palette';
import checkShade from '../utils/check-shade';
import reduceColorPointByStep from '../utils/reduce-color-point-by-step';

const timePickerDarkRule = (params, { step, darkShade }) => {
  const { targetColor, targetColorPalette } = params;
  const fallback = {
    rule: 'timePicker.plateBackground.dark',
    params,
  };
  const targetShade = findColorShadeInPalette(targetColor, targetColorPalette);

  if (checkShade(targetShade, (shade) => shade >= 300)) {
    return reduceColorPointByStep({ targetColor, targetColorPalette, step, fallback });
  }

  return targetColorPalette[darkShade];
};

export default timePickerDarkRule;
